import * as styles from '@classification-testing/components/ClassificationResultItemV2.css';
import type { ClassificationResult } from '@classification-testing/domain';
import { ContentType } from '@classification-testing/domain';
import { InlineAudioPlayer } from '@core/components';
import { BlurToggle } from '@soteria/design-system-ve';

interface ClassificationCardControlsProps {
  result: ClassificationResult;
  isSafe: boolean;
  isContentBlurred: boolean;
  onToggleBlur: (e: React.MouseEvent) => void;
  mediaServiceUrl?: string;
}

/**
 * Header actions — blur toggle and audio player
 */
export function ClassificationCardControls({ result, isSafe, isContentBlurred, onToggleBlur, mediaServiceUrl }: ClassificationCardControlsProps) {
  return (
    <div className={styles.headerActions}>
      {result.contentType === ContentType.AUDIO && result.contentUrl && (
        <div className={styles.audioPlayerSection}>
          <InlineAudioPlayer audioId={result.id} audioUrl={result.contentUrl} mediaServiceUrl={mediaServiceUrl} transcription={result.text} />
        </div>
      )}
      {!isSafe && <BlurToggle isBlurred={isContentBlurred} onToggle={onToggleBlur} />}
    </div>
  );
}
